import { get } from "lodash-es";
import { useMemo } from "react";
import create from "zustand";

export type SeasonalEntity = "league" | "community" | "tournament";

type SeasonMapKey = `${SeasonalEntity}${string}`;

export interface CurrentSeasonState {
  seasonMap: Record<SeasonMapKey, number>;
  setSeason: (
    seasonal: SeasonalEntity,
    slug: string,
    season: number
  ) => unknown;
}

export const useCurrentSeasonState = create<CurrentSeasonState>((set) => ({
  seasonMap: {},
  setSeason(entity, slug, season) {
    set(({ seasonMap }) => ({
      seasonMap: { ...seasonMap, [`${entity}${slug}`]: season },
    }));
  },
}));

export function useCurrentSeason(
  entity: SeasonalEntity,
  slug: string
): number | undefined {
  const map = useCurrentSeasonState((s) => s.seasonMap);
  return useMemo(() => get(map, `${entity}${slug}`), [entity, map, slug]);
}

export function useCurrentSeasonSet(): CurrentSeasonState["setSeason"] {
  return useCurrentSeasonState((s) => s.setSeason);
}
